import React, { useEffect, useState, useMemo } from "react";

//UI
import { Select } from "../../Common/Input/index";

//processing
import { useGetAllProperties } from "../../../hooks/Onboarding/onboarding-properties.hooks";

const OnboardingPropertyDropdown = (props) => {
  const { setProperty, property, customer } = props;

  const { data: propertyData } = useGetAllProperties();

  const options = useMemo(() => {
    if (propertyData) {
      let tempData = [...propertyData];

      if (customer) {
        tempData = tempData.filter((propert) => {
          return propert.customer_id === customer;
        });
      }

      return tempData.map((property) => {
        return {
          value: property._id,
          label: property.property_name,
        };
      });
    }
  }, [propertyData, customer, property]);

  return (
    <Select
      style={{ width: "100%", minWidth: "200px" }}
      onChange={setProperty}
      showSearch
      options={options}
      value={property}
      defaultValue={undefined}
      placeholder="Property Name"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default OnboardingPropertyDropdown;
